<template>
  <q-field
    :error="errors.has('language')"
    :error-label="errors.first('language')"
    :label="labelWidth ? $t('language') : ''"
    :labelWidth="labelWidth"
  >
    <q-select
      :value="value"
      v-validate.disable="'required|locale'"
      data-vv-name="language"
      :placeholder="$t('language')"
      :options="languageOptions"
      @input="_emit"
    />
  </q-field>
</template>

<script>
  import { general } from 'src/config'

  export default {
    inject: ['$validator'],

    props: {
      value: {
        type: String,
        required: true
      },

      labelWidth: {
        type: Number,
        default: null
      }
    },

    computed: {
      languageOptions: function () {
        return general.locales
      }
    },

    methods: {
      _emit (newVal) {
        this.$emit('input', newVal)
      }
    }
  }
</script>
